export default __webpack_public_path__ + "static/media/mad-renais01.36f21c58.png";